import React from "react";
import PageHeader from "../../components/PageHeader";
import TrackingMainScreen from "../views/TrackMainScreen";
import { useEffect } from "react";
import { searchAwb } from "../../utils/api";
import { useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Flip, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { getAWBSuccess } from "../../store/actions/awb";
import { getAWBFailure } from "../../store/actions/awb";
import {
  setCompanyInfo,
  initiateApiCall,
} from "../../store/actions/companyInfo";
import RatingCard from "../../components/RatingCard";
import { useState } from "react";
import styles from "./style.module.css";
import { verifyOtpActionForEdit } from "../../utils/api";
import RadarMapView from "../views/RadarMapView";
import moment from "moment";
import { classifyRemark, setContext, timer, track, trackError } from "../../analytics";
import usePageView from "../../analytics/usePageView";
import { getTone } from "../views/TrackMainScreen/resultState";
import { useQueryParams } from "../../utils/hooks/useQueryParams";
import { useCallSession } from "../../utils/hooks/useCallSession";
import CallSessionModal from "../../components/atoms/CallSessionModal";
import { getRadarData } from "../../utils/api/radar";
import HeaderWarning from "../../components/HeaderWarning";
import { getOrderSummary } from "../../utils/functions";
import { ensureOtpSessionFor } from "../../utils/otpSession";
const MainLayout = () => {
  const param = useParams();
  // A saved OTP session belongs to one AWB: drop it when this page is for another one.
  ensureOtpSessionFor(param.awbInfo);
  const trackdata = useSelector((store) => store?.awbReducer?.data);
  
  // Query parameters and call session logic
  const { createCallSession: shouldCreateCallSession } = useQueryParams();
  const [showCallSessionModal, setShowCallSessionModal] = useState(false);
  
  const {
    isLoading: callSessionLoading,
    error: callSessionError,
    phoneNumber,
    loadingStage,
    retry: retryCallSession,
    reset: resetCallSession
  } = useCallSession(param.awbInfo, shouldCreateCallSession);
  const ratingDeatils = useSelector(
    (store) => store?.awbReducer?.data?.ratingLog
  );
  const clinetName = trackdata?.companyInfo?.company_name;
  const [displayOtpPage, setotpPage] = useState(false);
  const [status, setstatus] = useState("");
  const [loadState, setLoadState] = useState("loading"); // loading | ok | error
  const orderDetailData = useSelector(
    (store) => store?.awbReducer?.data?.orderDetail
  );
  const [orderData, setOrderData] = useState([]);
  const dispatch = useDispatch();

  const optionsToast = {
    position: toast.POSITION.BOTTOM_CENTER,
    transition: Flip,
    toastClassName: "toast",
    closeButton: false,
  };

  const getAwb = async () => {
    setLoadState("loading");
    dispatch(initiateApiCall());
    const withOtp = !!sessionStorage.getItem("validateotp");
    const elapsed = timer();
    const attempt = ++loads.current;
    const data = withOtp
      ? await verifyOtpActionForEdit(JSON.parse(sessionStorage.getItem("otp")), param.awbInfo)
      : await searchAwb(param.awbInfo);

    // A failed call has no result: check the code before reading it (the old code threw here).
    if (data?.code === "200") {
      const result = data.result;
      const orderDetailData = result?.orderDetail;
      const { total, quantity } = getOrderSummary(orderDetailData);
      const codAmount = result?.trackingDetails?.[0]?.codAmount;
      const id = withOtp ? result?.shipmentDetails?.shopordernumber : parseInt((orderDetailData ?? []).slice(-1)[0]?.order_id) || 0;
      setOrderData([total, quantity, id, codAmount]);
      dispatch(setCompanyInfo(result?.companyInfo));
      dispatch(getAWBSuccess("data", result));
      setLoadState("ok");

      // Funnel: the result page has data. Context for every later event, then the load event.
      const shipment = result?.shipmentDetails;
      const edd = shipment?.buyerEDD || shipment?.estimateddateofdelivery;
      const tone = getTone(shipment?.shipmentstatus, shipment?.buyerEDD);
      setContext({ org_id: result?.companyInfo?.orgID, shipper_id: shipment?.shipperid, shipment_status: shipment?.shipmentstatus, tone });
      track("tp_result_loaded", {
        days_to_edd: edd ? moment.parseZone(edd).startOf("day").diff(moment().startOf("day"), "days") : undefined,
        delayed: tone === "delay",
        attempts: shipment?.deliveryAttempts,
        load_ms: elapsed(),
        loaded_with_otp: withOtp,
        retry: attempt - 1,
        ...(tone === "failed" ? classifyRemark(result?.trackingDetails?.[0]?.tracking?.[0]?.remarks) : {}),
      });
    } else {
      dispatch(getAWBFailure());
      setLoadState("error");
      toast.error("Something went wrong!!", optionsToast);
      trackError(withOtp ? "full_details" : "page_load", data, { retry: attempt - 1, load_ms: elapsed() });
    }
  };

  usePageView("result", { awb: param.awbInfo });
  const loads = React.useRef(0); // order calls on this page (retries)

  // Handle call session modal display
  useEffect(() => {
    if (shouldCreateCallSession) {
      setShowCallSessionModal(true);
    }
  }, [shouldCreateCallSession]);

  // Handle closing call session modal
  const handleCloseCallSessionModal = () => {
    setShowCallSessionModal(false);
    resetCallSession();
    
    // Remove the query parameter from URL
    const url = new URL(window.location);
    url.searchParams.delete('createCallSession');
    window.history.replaceState({}, '', url);
  };

  useEffect(() => {
    getAwb();
  }, []);


  const [tripData, setTripData] = useState(null);

    //Fetching data from sarathy
    const fetchRadarData = async () => {
      if (param.awbInfo == null || param.awbInfo === "") return;
      const res = await getRadarData(param.awbInfo);
      if (!res) {
        trackError("radar", null);
        return;
      }
      setTripData(res.data);
    };
  
    useEffect(() => {
      (async () => {
        await fetchRadarData();
      })();
    }, []);

  // Show the page only for this AWB's data (the store can still hold the previous AWB).
  const ready =
    !!trackdata?.shipmentDetails &&
    String(trackdata.shipmentDetails.awbnumber ?? param.awbInfo).toLowerCase() === String(param.awbInfo).toLowerCase();
  const isDelivered = trackdata?.shipmentDetails?.shipmentstatus === "Delivered";

  const ratingCards = isDelivered ? (
    <RatingCard awb={param.awbInfo} ratingLog={ratingDeatils} riderName={tripData?.riderName} brand={clinetName} />
  ) : null;

  return (
    <>
      <PageHeader forceLogo={loadState === "error"} chat />
      <HeaderWarning />
      <main className={styles.main}>
        <div className={styles.inner}>
          {/* Live map: renders only for an ONGOING trip (see RadarMapView). */}
          <RadarMapView shipmentStatus={tripData?.tripStatus} />
          {ready ? (
            <TrackingMainScreen
              orderData={orderData}
              shipmentstatuses={trackdata?.shipmentDetails?.shipmentstatus}
              tripData={tripData}
              ratings={ratingCards}
            />
          ) : loadState === "error" ? (
            <div className={styles.errorCard}>
              <h2 className={styles.errorTitle}>We couldn't load your order</h2>
              <span className={styles.errorText}>Check your connection and try again.</span>
              <button
                type="button"
                className={styles.retry}
                onClick={() => {
                  track("tp_cta_click", { cta: "try_again", placement: "error_card" });
                  getAwb();
                }}
              >
                Try again
              </button>
            </div>
          ) : (
            <div className={styles.skeleton} aria-busy="true" aria-label="Loading your order">
              <div className={styles.skelTop}>
                <div className={`${styles.skel} ${styles.skelEdd}`} />
                <div className={`${styles.skel} ${styles.skelStatus}`} />
              </div>
              <div className={`${styles.skel} ${styles.skelRow}`} />
              <div className={`${styles.skel} ${styles.skelDetails}`} />
            </div>
          )}
        </div>
      </main>
      <CallSessionModal
        isOpen={showCallSessionModal}
        onClose={handleCloseCallSessionModal}
        phoneNumber={phoneNumber}
        loading={callSessionLoading}
        error={callSessionError}
        loadingStage={loadingStage}
        onRetry={retryCallSession}
      />
    </>
  );
};

export default MainLayout;
